<template>
  <v-row justify="center" class="pt-4">
    <v-col align="center">
      <close-app-logo />
      <div class="title-page font-weight-medium">{{ title }}</div>
    </v-col>
  </v-row>
</template>
<script>
import CloseAppLogo from "./CloseAppLogo";

export default {
  name: 'LogoWithTitle',
	props: {title: String},
  components: { CloseAppLogo }
}
</script>
